import { initSliders } from "./sliders";
import { initMenu } from "./menu";
import { initSearchBar } from "./search-bar";
import { initProductVariants } from "./product-variants";
import { initSidecartOverlays } from "./sidecart-overlay";
import { initSideCart } from "../ts/SideCart";
import { initCartGamification } from "./cart-gamification";
import { initTabsWidget } from "./tabs-widget";
import { initQuickView } from "./quick-view";
import { initPDMFeatureFlags } from "./pdm-feature-flags";
import { initSeeInAction } from "./see-in-action";
import { initProductVideoCarousel } from "./product-video-carousel";
import { initProductCardSwipers } from "./product-card-slide";
import { initPackPreselection } from "./pack-selection";
import { initClaimsProductTooltip } from "./claims-product-tooltip";
import { initSideCartUpsells } from "./init-side-card-upsells";
import { initSideCartPromoUpsell } from "./init-side-cart-promo-upsell";
import { initBullshotGalleryImageSwap } from "./bullshot-gallery-image-swap";


document.addEventListener("DOMContentLoaded", () => {
  initSliders();
  initMenu();
  initSearchBar();
  initProductVariants();
  initSidecartOverlays();
  initSideCart();
  initCartGamification();
  initTabsWidget();
  initQuickView();
  initPDMFeatureFlags();
  initSeeInAction();
  initProductVideoCarousel();
  initProductCardSwipers();
  initPackPreselection();
  initClaimsProductTooltip();
  initSideCartUpsells();
  initSideCartPromoUpsell();
  initBullshotGalleryImageSwap();

  // Swiper loop clones slides after init; bind any forms created after first pass
  requestAnimationFrame(() => {
    const sideCart = document.querySelector("side-cart");
    if (sideCart && typeof sideCart.initializeNewAddToCartForms === "function") {
      sideCart.initializeNewAddToCartForms();
    }
  });
});
